const WARNING_SELECTOR = '[data-maurten-external-link-warning]';
const CONTINUE_SELECTOR = '[data-maurten-external-link-continue]';
const CANCEL_SELECTOR = '[data-maurten-external-link-cancel]';
const EXCLUDED_SELECTOR = [
  '[download]',
  '[aria-disabled="true"]',
  '[data-shopify]',
  '[data-shopify-editor-block]',
  '[data-shopify-editor-section]',
].join(',');

let pendingLink = null;

function getWarningComponent() {
  return document.querySelector(WARNING_SELECTOR);
}

function getWarningDialog() {
  return getWarningComponent()?.querySelector('dialog');
}

function isPlainLeftClick(event) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

function isMaurtenUrl(url) {
  const host = url.hostname.toLowerCase();
  return host === 'maurten.com' || host.endsWith('.maurten.com');
}

function isEligibleLink(link) {
  if (!(link instanceof HTMLAnchorElement)) return false;
  if (!link.href || link.matches(EXCLUDED_SELECTOR)) return false;

  const href = link.getAttribute('href')?.trim();
  if (!href || href.startsWith('#')) return false;

  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch {
    return false;
  }

  if (url.origin === window.location.origin) return false;
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

  return isMaurtenUrl(url);
}

function clearPendingLink() {
  pendingLink = null;

  const dialog = getWarningDialog();
  if (!dialog) return;

  delete dialog.dataset.pendingHref;
  delete dialog.dataset.pendingTarget;
}

function closeWarning() {
  const component = getWarningComponent();

  if (typeof component?.closeDialog === 'function') {
    component.closeDialog();
  } else {
    getWarningDialog()?.close();
  }

  clearPendingLink();
}

function openWarning(link) {
  const component = getWarningComponent();
  const dialog = getWarningDialog();

  if (!component || !dialog) return false;

  pendingLink = {
    href: link.href,
    target: link.target,
  };

  dialog.dataset.pendingHref = pendingLink.href;
  dialog.dataset.pendingTarget = pendingLink.target;

  if (typeof component.showDialog === 'function') {
    component.showDialog();
  } else {
    dialog.showModal();
  }

  return true;
}

function continueToPendingLink() {
  if (!pendingLink?.href) return;

  const { href, target } = pendingLink;
  closeWarning();

  if (target && target !== '_self') {
    window.open(href, target, 'noopener,noreferrer');
    return;
  }

  window.location.href = href;
}

document.addEventListener('click', (event) => {
  const clickedElement = event.target;
  if (!(clickedElement instanceof Element)) return;

  const continueButton = clickedElement.closest(CONTINUE_SELECTOR);
  if (continueButton) {
    event.preventDefault();
    continueToPendingLink();
    return;
  }

  const cancelButton = clickedElement.closest(CANCEL_SELECTOR);
  if (cancelButton) {
    event.preventDefault();
    closeWarning();
    return;
  }

  if (event.defaultPrevented || !isPlainLeftClick(event)) return;

  const link = clickedElement.closest('a[href]');
  if (!isEligibleLink(link)) return;

  if (openWarning(link)) {
    event.preventDefault();
  }
});

document.addEventListener('dialog:close', (event) => {
  if (event.target?.matches?.(WARNING_SELECTOR)) {
    clearPendingLink();
  }
});
